import { Component } from '@angular/core'

@Component({
    selector: 'lg-no-chantier',
    templateUrl: './no-chantier.component.html'
})
export class NoChantierComponent {}
